module.exports = __webpack_public_path__ + "img/icon_map_37_on_100.e8bc9d46.png";